import React from 'react'
import { RadioGroupContainer, RadioGroupItem, RadioGroupInput, RadioGroupLabel } from '../atoms/RadioGroup.styled';

interface RadioGroupProps {
    options: { id: number; text: string }[];
    onChange: (value: string) => void;
}

export const RadioGroup = ({ options, onChange }: RadioGroupProps) => {
    return (
        <RadioGroupContainer>
            {options.map((option) => (
                <RadioGroupItem key={option.id}>
                    <RadioGroupInput type="radio" value={option.text} name='radio-group' onChange={(e) => onChange(e.target.value)} />
                    <RadioGroupLabel>{option.text}</RadioGroupLabel>
                </RadioGroupItem>
            ))}
        </RadioGroupContainer>
    )
}